export const mobile = `<svg aria-hidden="true" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 32">
<path d="M17 0c1.656 0 3 1.344 3 3v26c0 1.656-1.344 3-3 3h-14c-1.656 0-3-1.344-3-3v-26c0-1.656 1.344-3 3-3h14zM10 30c1.106 0 2-0.894 2-2s-0.894-2-2-2-2 0.894-2 2 0.894 2 2 2z"></path>
</svg>`;
